module.exports = __webpack_public_path__ + "static/media/HaDo.233e10f5.png";